import React from 'react';
import { observer } from 'mobx-react';
import Styles from './index.module.scss';
import i18next from 'i18next';

interface Props{
  id?: number;
}

const Placeholder: React.FC<Props> = (prop) => (
  <div className={Styles.placeholder}>
    {prop.id ? (
      <>
        <div className={Styles.progress}>
          <div id={`myProgress-${prop.id}`} className={Styles.bar} />
        </div>
        <span id={`myProgressNum-${prop.id}`} />
      </>
    ) : <div>{i18next.t('img_loading')}</div>}
  </div>
);

export default React.memo(observer(Placeholder));
